export default "__VITE_PUBLIC_ASSET__983da1b8__"